<template>
    <div class="general-data-config">
        <h1>Configuration de la base de données</h1>

        <div class="universal-filter-container">
            <input
            type="text"
            v-model="universalFilterText"
            placeholder="Filtrer les lignes par leur intitulé..."
            class="filter-input">
        </div>

        <div v-for="(chapter, chapterName) in filteredData" :key="chapterName">
            <h2>{{ chapterName }}</h2>
            <table>
                <thead>
                    <tr>
                        <th>Affectation</th>
                        <th v-for="symbol in chapter.symbols" :key="symbol.tag" :title="symbol.description" v-html="symbol.description + symbol.symbol + '[' + symbol.unit + ']'"/>
                    </tr>

                </thead>
                <tbody>
                    <tr v-for="(row, title) in chapter.rows" :key="title">
                        <td>{{ row.title }}</td>
                        <td v-for="symbol in chapter.symbols" :key="symbol.tag">
                            <input 
                            type="text"
                            :disabled="isLocked"
                            :placeholder="symbol.tag" 
                            :value="formatNumberWithSeparator(row.values[symbol.tag], symbol.tag)" 
                            @focus="$event.target.value = row.values[symbol.tag]"
                            @blur="updateTableValue(symbol.tag, row, $event.target.value);
                            $event.target.value = formatNumberWithSeparator(row.values[symbol.tag], symbol.tag)"
                            @keydown.enter="$event.target.blur()"/>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-for="(item) in chapter.singles" :key="item.tag" class="single-item">
                <span class="tag">{{item.tag}}</span><!-- &nbsp;--&nbsp; --><span class="description">{{item.description}}</span>
                <input 
                    type="text" 
                    class="number"
                    :disabled="isLocked"
                    :placeholder="item.tag" 
                    :value="formatNumberWithSeparator(item.value, item.tag)" 
                    @focus="$event.target.value = item.value"
                    @blur="handleBlur(item, $event)"
                    @keydown.enter="$event.target.blur()"
                />
                <!-- Can't replace v-html because of the <sup> and <sub> tags -->
                    <span v-if="item.unit" class="unit" v-html="item.unit"></span>
            </div>
        </div>
    </div>
</template>$

<script>
import { mapGetters, mapState } from 'vuex';
import '../../assets/styles/base.css'
import '../../assets/styles/table.css';

export default {
    name: 'GeneralDataConfig',
    data() {
        return {
            universalFilterText: '',
        }
    },
    computed: {
        ...mapState("referential", ["selectedReferential", "referentialDatabase"]),
        ...mapGetters("referential", ["isReferentialLocked", "getDatabaseChapters", "getDatabaseForChapter", "getGroupedDatabase", "formatNumberWithSeparator"]),
        isLocked() {
            return this.isReferentialLocked(this.selectedReferential)
        },
        filteredData() {
        if (!this.universalFilterText) {
            return this.getGroupedDatabase;
        }

        const filterText = this.universalFilterText.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');

        return Object.keys(this.getGroupedDatabase).reduce((acc, chapterName) => {
            const chapter = this.getGroupedDatabase[chapterName];

            const filteredSingles = Object.values(chapter.singles).filter(item => {
                const tag = item.tag || '';
                const description = item.description || '';
                return tag.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(filterText) ||
                       description.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(filterText);
            });

            const filteredRows = Object.keys(chapter.rows).reduce((rowAcc, rowTitle) => {
                if (rowTitle.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(filterText)) {
                    rowAcc[rowTitle] = chapter.rows[rowTitle];
                }
                return rowAcc;
            }, {});

            if (Object.keys(filteredRows).length > 0 || filteredSingles.length > 0) {
                acc[chapterName] = {
                    ...chapter,
                    rows: filteredRows,
                    singles: filteredSingles,
                };
            }

            return acc;
        }, {});
    },
    },
    mounted() {
        //console.log("state referential:", this.$store.state.referential)
        if(this.selectedReferential === 0) {
            if(this.$route.params.id) {
                this.$store.commit("referential/selectTreeMutation", this.$route.params.id)
            }
            //console.log("loaded referential: ", this.selectedReferential)
        } else {
            //console.log("Referential already loaded")
        }
        this.$store.dispatch("referential/fetchReferentialDatabase", {
            id: this.selectedReferential,
        })
    },
    methods: {
       /*  focusNext(event) {
            event.preventDefault();
            const inputs = Array.from(document.querySelectorAll('input.matrix-input'));
            //console.log(inputs);
            const currentIndex = inputs.indexOf(event.target);
            //console.log(currentIndex);

            if (currentIndex !== -1 && currentIndex < inputs.length - 1) {
            inputs[currentIndex + 1].focus();
            }
        }, */
        handleBlur(item, event) {
            const rawUserInput = event.target.value;
            this.updateSingleValue(item, rawUserInput);
            const cleanedRawValue = rawUserInput.replace(/['’\s]/g, '').replace(/,/g, '.');
            const cleanValue = parseFloat(cleanedRawValue);
            if (!isNaN(cleanValue)) {
                event.target.value = this.formatNumberWithSeparator(cleanValue, item.tag);
            } else {
                event.target.value = this.formatNumberWithSeparator(item.value, item.tag);
            }
        },

        updateSingleValue(item, rawValue) {
            //console.log("updating ? item : ", item)
            const cleanedRawValue = rawValue.replace(/['’\s]/g, '').replace(/,/g, '.')
            const cleanValue = parseFloat(cleanedRawValue);
            //console.log("updating single value: item.tag=", item.tag,"\ncleanedRawValue:", cleanedRawValue, "\ncleanValue:", cleanValue, "\nrawValue:",rawValue);
            /* if (isNaN(cleanValue)) {
                this.$forceUpdate(); 
                return; 
            } */

            this.$store.dispatch("referential/updateReferentialDatabase", {
                tag: item.tag,
                value: cleanValue, 
                database: item,
                type: 'single',
                index:-1,
            });
            /* this.$store.dispatch("referential/fetchReferentialDatabase", {
                id: this.selectedReferential,
            }) */

        },

        updateTableValue(tag, row, rawValue) {
            const cleanedRawValue = rawValue.replace(/['’\s]/g, '').replace(/,/g, '.')
            const cleanValue = parseFloat(cleanedRawValue);
            //console.log("updating TableValue:: item.tag=", tag,"\nrow.index :",row.index,"\ncleanedRawValue:", cleanedRawValue, "\ncleanValue:", cleanValue, "\nrawValue:",rawValue);
            /* if (isNaN(cleanValue)) {
                this.$forceUpdate();
                return;
            } */
            this.$store.commit("referential/updateReferentialSingleValueMutation", {
                tag: tag,
                value: cleanValue,
                index: row.index,
            });
            
            const firstIndex = this.referentialDatabase.findIndex(item => item.tag === tag);
            
            this.$store.dispatch("referential/updateReferentialDatabase", {
                index: firstIndex,
                database: this.referentialDatabase[firstIndex],
                type: 'array',
            });
        },
        formatValues(values) {
            return values.map(value => [value]);
        },
        /* formatSymbolHeader(symbol) {
            return `${symbol.description}\n${symbol.symbol} [${symbol.unit}]`;
        }, */
    },
};
</script>

<style scoped>
.general-data-config {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

table {
    border-collapse: collapse;
    margin-block-end: inherit;
    table-layout: fixed;
}
th {
    border: 1px solid #ddd;
    padding: 8px;
    background-color: #f2f2f2;
    text-align: left;
    box-sizing: border-box;
    word-wrap: break-word;
    overflow-wrap: break-word;
}
td {
    border: 1px solid #b1b1b1;
    padding: 8px;
    font-size: small;
    box-sizing: border-box;
}

input {
    width: 100%;
    border: none;
    padding: 8px;
    box-sizing: border-box;
    min-width: 0;
}

input.number{
    border: 1px solid #ddd;
}

input.number > div{
    position:absolute;
    left: 5%;
}

.single-item{
    display: grid;
    grid-template-columns: 8% 55% 16% 10%  ;
}

.single-item .description{
    text-align: start;
}

</style>